"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _creditCardSearch = _interopRequireDefault(require("./components/credit-card-search/credit-card-search"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _creditCardSearch.default;
exports.default = _default;